<template>
  <div class="widget">
      <div v-if="loading === 'tokens'">
          <h1>Logging you with Envato</h1>
          <Spinner></Spinner>
          <p>Please wait while we log you in</p>
      </div>
      <div v-else-if="loading === 'error'">
          <h1>Oops, something went wrong!</h1>
          <img src="../assets/pisica.svg" style="max-width: 28rem;margin: 0 auto 3rem">
          <p>Please <router-link to="/">go back</router-link> and try again</p>
      </div>
  </div>
</template>

<script>
    /*eslint no-console: "error"*/
  import Spinner from '@/components/Spinner'
  import axios from 'axios'
    import tokensMixins from '@/mixins/tokens'

export default {
    name: 'Logged',
    props: {
        code: String
    },
    data: function(){
      return {
          loading: 'tokens',
          products: []
      }
    },
    components: {
        Spinner
    },
    mounted: function(){
      var vm = this
      if( typeof vm.$route.params !== 'undefined' && typeof vm.$route.params.code !== 'undefined' ){
        vm.getTokens()
      } else if( vm.hasTokens() && ! vm.isTokenValid() ){
          vm.refreshTokens()
      } else {
          vm.$router.push({path: '/products'})
      }
    },
    methods: {
        refreshTokens: function(){
          var vm = this
            axios.get('https://my.curlythemes.com/.netlify/functions/refreshTokens',{
                params: {
                    token: vm.getRefreshToken()
                }
            })
            .then(function (response) {
                if( response.status === 200 ){
                    response.data.expires_in = Math.round( (new Date().getTime()) / 1000 ) + response.data.expires_in
                    response.data.refresh_token =  vm.getRefreshToken()
                    localStorage.setItem( 'curlyTokens', JSON.stringify( response.data ))
                    vm.$router.push({path: '/products'})
                } else {
                    vm.loading = 'error'
                    localStorage.clear()
                }
            })
            .catch(function () {
                vm.loading = 'error'
                localStorage.clear()
            })
        },
        getTokens: function(){
            var vm = this
            axios.get('https://my.curlythemes.com/.netlify/functions/tokens',{
                params: {
                    code: vm.$route.params.code
                }
            })
            .then(function (response) {
                if( response.status === 200 ){
                    response.data.expires_in = Math.round( (new Date().getTime()) / 1000 ) + response.data.expires_in
                    localStorage.setItem( 'curlyTokens', JSON.stringify( response.data ))
                    vm.$router.push({path: '/products'})
                } else {
                    vm.loading = 'error'
                }
            })
            .catch(function () {
                vm.loading = 'error'
            })

        }
    },
    mixins: [ tokensMixins ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
